import { useContext, useMemo } from "react";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import { productPrice } from "./product-price.scss";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { getCurrencyName, getCurrencyWithPriceDisplay } from "/services/pricing-service";

export const ProductPrice = ({ pricePerSeat, period, seats, tierName, product }) => {
  const {
    translate,
    translateOrTranslateWithParam,
    currency: currencyFromContext,
    localeId,
    forceCurrency,
    cloudfrontViewerCountry
  } = useContext(GenericConfigContext);
  const currency = currencyFromContext || getCurrencyName({ forceCurrency, countryCode: cloudfrontViewerCountry });
  const productPricePerMonth = pricePerSeat[period][currency];
  const corePricePerMonth = useMemo(
    () => productPricingConfig.core.tiers.find((tier) => tier.name === tierName).pricePerSeat[period][currency],
    [period, tierName]
  );
  const totalPricePerMonth = product === "core" ? productPricePerMonth : productPricePerMonth + corePricePerMonth;
  const pricePerSeatText = getCurrencyWithPriceDisplay({
    price: totalPricePerMonth.toLocaleString(),
    currency,
    localeId
  });
  return (
    <div className="price">
      <div className="price-tag">
        <div className="amount">{pricePerSeatText}</div>
        <div className="price-description">
          {totalPricePerMonth > 0 ? (
            <>
              {translate("pricingPage.seatOver")}
              <br /> {translate("pricingPage.month")}
            </>
          ) : (
            <>
              {translate("pricingPage.free")}
              <br /> {translate("pricingPage.forever")}
            </>
          )}
        </div>
      </div>
      <div className="total">
        {totalPricePerMonth > 0
          ? translateOrTranslateWithParam({
              key: "pricingPage.total.withNumber",
              param: `$${(totalPricePerMonth * seats).toLocaleString()}`
            })
          : translateOrTranslateWithParam({
              key: "pricingPage.upToXSeats",
              param: `2`
            })}
      </div>
      {totalPricePerMonth > 0 && <div>{translate(`pricingPage.periods.${period}.billed`)}</div>}
      <div />
      <style jsx>{productPrice}</style>
    </div>
  );
};
